import * as types from './ActionTypes';
import notesApiService from './notesApiService'; 
// Ensure this import matches the export in Utils/DisplayGlobalMessage.js
import displayGlobalMessage from '../../Utils/DisplayGlobalMessage'; 

// Fetch all notes for a specific concept
export const getNotes = (conceptId) => {
    return async (dispatch) => {
        dispatch({ type: types.GET_NOTES_REQUEST });
        try {
            const response = await notesApiService.fetchNotes(conceptId);
            dispatch({ type: types.GET_NOTES_SUCCESS, payload: response.data });
        } catch (err) {
            dispatch({ type: types.GET_NOTES_FAILED });
            displayGlobalMessage("Failed to load notes.", "error");
        }
    };
};

// Create a new note
// Note: This matches the 'createNote' import used in NoteEditor.jsx
export const createNote = (noteData) => {
    return async (dispatch) => {
        dispatch({ type: types.ADD_NOTE_REQUEST });
        try {
            const response = await notesApiService.addNote(noteData);
            dispatch({ type: types.ADD_NOTE_SUCCESS, payload: response.data });
            displayGlobalMessage("Note added successfully.", "success");
        } catch (err) {
            dispatch({ type: types.ADD_NOTE_FAILED });
            displayGlobalMessage("Failed to add note.", "error");
        }
    };
};

// Update an existing note
export const updateNoteAction = (noteId, noteData) => {
    return async (dispatch) => {
        dispatch({ type: types.UPDATE_NOTE_REQUEST });
        try {
            const response = await notesApiService.updateNote(noteId, noteData);
            dispatch({ type: types.UPDATE_NOTE_SUCCESS, payload: response.data });
            displayGlobalMessage("Note updated successfully.", "success");
        } catch (err) {
            dispatch({ type: types.UPDATE_NOTE_FAILED });
            displayGlobalMessage("Failed to update note.", "error");
        }
    };
};

// Delete a note
export const deleteNoteAction = (noteId) => {
    return async (dispatch) => {
        dispatch({ type: types.DELETE_NOTE_REQUEST });
        try {
            await notesApiService.deleteNote(noteId);
            dispatch({ type: types.DELETE_NOTE_SUCCESS, payload: noteId });
            displayGlobalMessage("Note deleted successfully.", "success");
        } catch (err) {
            dispatch({ type: types.DELETE_NOTE_FAILED });
            displayGlobalMessage("Failed to delete note.", "error");
        }
    };
};